import _ from 'lodash';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link, IndexLink } from 'react-router';
import './navbar.scss';
let logo = require('./logo.svg');
import * as actions from '../../actions/userActions';
import PermissionWrapper from '../common/PermissionWrapper';
import * as perm from '../../permission';

class NavBar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.LogoutLink = this.LogoutLink.bind(this);
    this.LoginLink = this.LoginLink.bind(this);
    this.CurrentUserLink = this.CurrentUserLink.bind(this);
    this.ClubLink = this.ClubLink.bind(this);
    this.EventsLink = this.EventsLink.bind(this);
  }

  LogoutLink() {
    if (!this.props.users.loggedIn) {
      return null;
    }
    return (<li><a onClick={() => {this.props.actions.logout();}}>Log ut</a></li>);
  }

  LoginLink() {
    if (this.props.users.loggedIn) {
      return null;
    }
    return (<li><Link to="/login">Log inn</Link></li>);
  }

  ClubLink() {
    if (!this.props.users.loggedIn || !this.props.users.currentUser) {
      return null;
    }
    if (perm.hasGlobalPermission(
          this.props.users.currentUser,
          ['super_admin']
        ) || (!_.isEmpty(this.props.users.currentUser.clubs) && this.props.users.currentUser.clubs.length >= 2)) {
      return (<li className={""}><Link to="/klubber">Klubber</Link></li>);
    }
    if (_.isEmpty(this.props.users.currentUser.clubs)) {
      return null;
    }
    return <li className={""}><Link to={'/klubb/' + this.props.users.currentUser.clubs[0].id}>Min klubb</Link></li>;
  }

  EventsLink() {
    if (!this.props.users.loggedIn) {
      return null;
    }
    return (<li className={""}><Link to="/">Påmelding</Link></li>);
  }

  CurrentUserLink() {
    if (!this.props.users.loggedIn) {
      return null;
    }
    return (
      <li>
        <Link to={'/bruker/'+ this.props.users.currentUser.id}>
          Min bruker
        </Link>
      </li>
    );
  }

  render() {
    // navbar-fixed-top
    return (
      <nav className="navbar navbar-default navbar-custom">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <IndexLink className="navbar-brand" to="/">
              <img
              className="nav-bar-logo"
              src={logo}
              alt="Norsk Amerikanske Idretters Forbund"/>
            </IndexLink>
          </div>
          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul className="nav navbar-nav">
              {this.EventsLink()}
              {this.ClubLink()}
              <PermissionWrapper allowed={['super_admin']}>
                <li><Link to={'/brukere'}>Brukere</Link></li>
              </PermissionWrapper>
            </ul>
            <ul className="nav navbar-nav navbar-right">
              {this.CurrentUserLink()}
              {this.LoginLink()}
              {this.LogoutLink()}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
NavBar.propTypes = {
  // routes: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  users: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    users: state.users
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavBar);



/** WEBPACK FOOTER **
 ** ./src/components/navigation/NavBar.js
 **/